// extracted by mini-css-extract-plugin
export default {"heading":"TextSection-module__heading__v0s8Q"};